import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const cookies = new Cookies();

/**
 * تقارير أجهزة purchase_device — عرض وفلترة فقط، لا يعدّل شيئاً.
 *
 * ملاحظة على عمودَي الحالة: التقرير يعرض «الحالة» (status) و«الوضع»
 * (state) معاً عمداً. status وحده يكذب — جهاز الصيانة يبقى sana بعد
 * أن يُعدّ، والمرفوض يبقى بحالته القديمة مع is_rejected = 1.
 *
 * ⚠️ react-scripts 3.3.1: لا optional chaining ولا nullish coalescing.
 *
 * التنسيق في ورقة أنماط واحدة بسابقة dr- بدل أنماط سطرية متناثرة:
 * التخطيط يحتاج :hover و nth-child و sticky و media queries، وكلها
 * لا تُكتب سطرياً. السابقة تمنع التصادم مع أنماط اللوحة العامة.
 */

const CSS = `
.dr-root{
  --bg:#eef2f7; --card:#fff; --line:#e3eaf2; --line2:#eef3f8;
  --ink:#0a1018; --mut:#3f5063; --faint:#5f7288;
  --acc:#1749c9; --acc-soft:#eaf1ff;
  direction:rtl; background:var(--bg); min-height:100vh; padding:26px 0 40px;
  font-family:'Tajawal','Dubai',"Segoe UI","Noto Kufi Arabic",Tahoma,Arial,sans-serif;
  color:var(--ink); font-size:17px; line-height:1.6;
  -webkit-font-smoothing:antialiased; text-rendering:optimizeLegibility;
}
.dr-shell{ padding-inline:max(18px,calc((100% - 1560px)/2)); box-sizing:border-box; }

.dr-head{ display:flex; align-items:flex-end; justify-content:space-between; gap:18px; flex-wrap:wrap; margin-bottom:20px; }
.dr-h1{ font-size:32px; font-weight:800; letter-spacing:-.4px; margin:0 0 6px; }
.dr-sub{ font-size:16.5px; color:var(--mut); margin:0; max-width:62ch; }

.dr-card{ background:var(--card); border:1px solid var(--line); border-radius:18px; box-shadow:0 1px 2px rgba(15,23,42,.04); margin-bottom:18px; }
.dr-pad{ padding:20px 22px; }

/* ---- مبدّل العرض ---- */
.dr-seg{ display:inline-flex; background:#fff; border:1px solid var(--line); border-radius:14px; padding:5px; gap:5px; }
.dr-seg-btn{ font:inherit; font-size:16.5px; font-weight:700; padding:10px 20px; border:0; border-radius:10px; background:transparent; color:var(--mut); cursor:pointer; transition:background .15s,color .15s; }
.dr-seg-btn:hover{ color:var(--ink); background:#f4f7fb; }
.dr-seg-btn.on{ background:var(--acc); color:#fff; }
.dr-seg-btn.on:hover{ background:var(--acc); }
.dr-seg-hint{ display:block; font-size:13px; font-weight:600; opacity:.7; margin-top:2px; }

.dr-crumb{ display:inline-flex; align-items:center; gap:11px; padding:12px 17px; border-radius:13px; background:var(--acc-soft); border:1px solid #bcd3fb; color:#153e9e; font-size:16.5px; font-weight:700; }
.dr-crumb b{ font-weight:800; }
.dr-x{ cursor:pointer; font-size:19px; line-height:1; font-weight:700; opacity:.6; background:none; border:0; color:inherit; padding:0 2px; font-family:inherit; }
.dr-x:hover{ opacity:1; }

/* ---- الفلاتر ---- */
.dr-grid{ display:grid; grid-template-columns:repeat(auto-fit,minmax(178px,1fr)); gap:15px; }
.dr-grid .dr-wide{ grid-column:span 2; }
@media (max-width:640px){ .dr-grid .dr-wide{ grid-column:span 1; } }
.dr-label{ display:block; font-size:14px; font-weight:700; color:var(--mut); margin-bottom:7px; }
.dr-input,.dr-select{ font:inherit; font-size:16.5px; width:100%; box-sizing:border-box; padding:11px 13px; border:1px solid #d8e2ee; border-radius:11px; background:#fff; color:var(--ink); outline:none; transition:border-color .15s,box-shadow .15s; }
.dr-input:focus,.dr-select:focus{ border-color:var(--acc); box-shadow:0 0 0 3px rgba(29,78,216,.13); }
.dr-input::placeholder{ color:var(--faint); }

.dr-bar-actions{ display:flex; gap:11px; flex-wrap:wrap; align-items:center; margin-top:18px; padding-top:17px; border-top:1px solid var(--line2); }
.dr-btn{ font:inherit; font-size:16.5px; font-weight:700; padding:11px 22px; border-radius:11px; border:1px solid transparent; cursor:pointer; transition:filter .15s,background .15s; }
.dr-btn:focus-visible{ outline:2px solid var(--acc); outline-offset:2px; }
.dr-btn-primary{ background:var(--acc); color:#fff; }
.dr-btn-primary:hover{ filter:brightness(1.08); }
.dr-btn-ghost{ background:#fff; color:#334155; border-color:#d8e2ee; }
.dr-btn-ghost:hover{ background:#f4f7fb; }
.dr-btn-ok{ background:#15803d; color:#fff; }
.dr-btn-ok:hover{ filter:brightness(1.08); }
.dr-btn:disabled{ opacity:.5; cursor:default; filter:none; }
.dr-toggle{ display:inline-flex; align-items:center; gap:10px; font-size:16px; font-weight:600; color:#334155; cursor:pointer; user-select:none; }
.dr-toggle input{ width:17px; height:17px; accent-color:var(--acc); cursor:pointer; }
.dr-spacer{ flex:1; }

/* ---- بطاقات الأرقام ---- */
.dr-stats{ display:grid; grid-template-columns:repeat(auto-fit,minmax(190px,1fr)); gap:14px; margin-bottom:18px; }
.dr-stat{ background:var(--card); border:1px solid var(--line); border-radius:16px; padding:17px 19px; }
.dr-stat-l{ font-size:14.5px; font-weight:700; color:var(--mut); margin-bottom:6px; }
.dr-stat-v{ font-size:32px; font-weight:800; letter-spacing:-.5px; font-variant-numeric:tabular-nums; }
.dr-stat-s{ font-size:14px; color:var(--faint); margin-top:4px; }

/* ---- الجدول ---- */
.dr-scroll{ overflow:auto; max-height:74vh; border-radius:18px; }
.dr-t{ width:100%; border-collapse:separate; border-spacing:0; font-size:16.5px; }
.dr-t th{ position:sticky; top:0; z-index:3; background:#f4f8fc; text-align:right; font-size:14.5px; font-weight:800; color:var(--mut); padding:14px 16px; border-bottom:1px solid var(--line); white-space:nowrap; }
.dr-t td{ padding:16px; border-bottom:1px solid var(--line2); vertical-align:top; text-align:right; }
.dr-t tbody tr:nth-child(even){ background:#fafcfe; }
.dr-t tbody tr:last-child td{ border-bottom:0; }
.dr-t tbody tr.dr-click{ cursor:pointer; transition:background .12s; }
.dr-t tbody tr.dr-click:hover{ background:var(--acc-soft); }
.dr-t tbody tr.dr-flag{ box-shadow:inset 3px 0 0 #dc2626; }
.dr-num{ font-variant-numeric:tabular-nums; font-weight:700; white-space:nowrap; }
.dr-count{ font-variant-numeric:tabular-nums; font-size:26px; font-weight:800; color:var(--acc); white-space:nowrap; }
.dr-mono{ font-family:"SF Mono",Consolas,monospace; font-size:15px; direction:ltr; text-align:right; unicode-bidi:plaintext; }
.dr-sep{ border-right:1px solid var(--line); }

/* ---- الاسم المركّب: الشرطة العمودية نحوٌ لا حرف ---- */
.dr-name{ display:flex; flex-wrap:wrap; align-items:center; gap:7px; }
.dr-model{ font-size:17.5px; font-weight:800; letter-spacing:-.2px; }
.dr-seg-chip{ font-size:14px; font-weight:700; color:#3d5573; background:#eef3f9; border:1px solid #dde6f0; border-radius:7px; padding:2px 8px; white-space:nowrap; }
.dr-seg-chip.k{ color:#7c2d12; background:#fff5eb; border-color:#fde3c7; }

/* ---- شريط التوزيع المجزّأ ---- */
.dr-dist{ display:flex; height:9px; border-radius:6px; overflow:hidden; background:#eef3f8; margin-top:9px; max-width:270px; }
.dr-dist i{ display:block; height:100%; }

.dr-badge{ display:inline-block; font-size:14px; font-weight:700; padding:5px 12px; border-radius:999px; white-space:nowrap; margin:0 0 4px 5px; border:1px solid transparent; }
.dr-tags{ display:flex; flex-wrap:wrap; gap:0; margin-top:6px; }

.dr-empty{ padding:64px 24px; text-align:center; color:var(--mut); font-size:17px; }
.dr-empty b{ display:block; font-size:20px; color:var(--ink); margin-bottom:7px; font-weight:800; }

/* ---- الصفحات ---- */
.dr-pager{ display:flex; gap:8px; justify-content:center; align-items:center; flex-wrap:wrap; margin:20px 0 34px; }
.dr-pg{ font:inherit; font-size:16px; font-weight:700; min-width:44px; padding:10px 15px; border-radius:11px; border:1px solid #d8e2ee; background:#fff; color:#334155; cursor:pointer; font-variant-numeric:tabular-nums; }
.dr-pg:hover:not(:disabled){ background:#f4f7fb; }
.dr-pg:disabled{ opacity:.38; cursor:default; }
.dr-pg.on{ background:var(--acc); border-color:var(--acc); color:#fff; }
.dr-pgtxt{ font-size:15.5px; color:var(--mut); margin-inline-start:10px; font-variant-numeric:tabular-nums; }

/* ---- نافذة التفاصيل ---- */
.dr-ov{ position:fixed; inset:0; background:rgba(11,18,32,.6); display:flex; align-items:center; justify-content:center; z-index:9999; padding:22px; }
.dr-modal{ background:#fff; border-radius:20px; width:min(820px,96vw); max-height:88vh; overflow-y:auto; direction:rtl; box-shadow:0 24px 60px rgba(0,0,0,.32); }
.dr-mhead{ position:sticky; top:0; background:#fff; padding:20px 24px; border-bottom:1px solid var(--line); display:flex; justify-content:space-between; align-items:flex-start; gap:16px; z-index:2; }
.dr-mbody{ padding:8px 24px 26px; }
.dr-sect{ font-size:14.5px; font-weight:800; color:var(--mut); margin:22px 0 4px; padding-bottom:8px; border-bottom:1px solid var(--line2); }
.dr-kv{ display:flex; gap:14px; padding:10px 0; border-bottom:1px solid #f4f8fc; }
.dr-kv:last-child{ border-bottom:0; }
.dr-k{ min-width:180px; font-size:15px; font-weight:700; color:var(--mut); }
.dr-v{ font-size:16.5px; word-break:break-word; flex:1; }
.dr-box{ background:#f7fafd; border:1px solid var(--line); border-radius:14px; padding:6px 17px 12px; margin-top:12px; }

/* ---- عرض «حسب الاسم»: مستويان ---- */
.dr-warn{ margin:14px 18px 0; padding:12px 16px; border-radius:12px; background:#fffbeb; border:1px solid #fde68a; color:#92400e; font-size:15.5px; font-weight:600; }
.dr-btn-sm{ padding:8px 15px; font-size:13.5px; }

.dr-t-models tbody tr.dr-mrow{ background:#f7fafd; }
.dr-t-models tbody tr.dr-mrow:hover{ background:var(--acc-soft); }
.dr-t-models tbody tr.dr-mrow td{ border-bottom:1px solid var(--line); }
.dr-mname{ font-size:19px; }
.dr-mcount{ font-size:29px; }
.dr-vcount{ font-size:13.5px; font-weight:700; color:var(--faint); background:#fff; border:1px solid var(--line); border-radius:999px; padding:2px 10px; }

.dr-caret{ display:inline-block; font-size:14px; color:var(--acc); transform:rotate(-90deg); transition:transform .15s; }
.dr-caret.on{ transform:rotate(0deg); }

.dr-t-models tbody tr.dr-vrow{ background:#fff; }
.dr-t-models tbody tr.dr-vrow:hover{ background:var(--acc-soft); }
.dr-t-models tbody tr.dr-vrow td:first-child{ padding-inline-start:44px; }
.dr-t-models tbody tr.dr-vrow td{ border-bottom:1px solid var(--line2); }
.dr-tree{ color:#a8bacd; font-size:15px; }
.dr-vcnt{ font-size:21px; color:#2563eb; }

.dr-t-models tbody tr.dr-trow{ background:#eef3f9; }
.dr-t-models tbody tr.dr-trow td{ border-top:2px solid var(--line); border-bottom:0; font-size:17px; padding-top:18px; padding-bottom:18px; }

@media (max-width:820px){
  .dr-mname{ font-size:17px; }
  .dr-mcount{ font-size:24px; }
  .dr-vcnt{ font-size:19px; }
  .dr-t-models tbody tr.dr-vrow td:first-child{ padding-inline-start:26px; }
}

@media (max-width:820px){
  .dr-root{ font-size:16px; }
  .dr-h1{ font-size:25px; }
  .dr-t th,.dr-t td{ padding:12px; }
  .dr-k{ min-width:130px; }
}
@media (prefers-reduced-motion:reduce){ .dr-root *{ transition:none !important; } }
`;

// نغمة موحّدة للحالة: خلفية · نص · إطار · لون صلب لشريط التوزيع
const STATUS_STYLE = {
  ready: ["#eff5ff", "#1d4ed8", "#c7dbfe", "#3b82f6"],
  sana: ["#fff5eb", "#c2410c", "#fde3c7", "#f97316"],
  soft: ["#f7f2ff", "#7c3aed", "#e6dbff", "#a855f7"],
  stocked: ["#eefbf3", "#15803d", "#c3ecd3", "#22c55e"],
  sold: ["#f1f5f9", "#475569", "#e2e8f0", "#94a3b8"],
};
const NEUTRAL = ["#f1f5f9", "#475569", "#e2e8f0", "#94a3b8"];
const STATE_STYLE = {
  rejected: ["#fef2f2", "#b91c1c", "#fdcdcd"],
  needs_fix: ["#fffbeb", "#b45309", "#fde68a"],
  unverified: ["#f5f8fb", "#526277", "#e3eaf2"],
  ok: ["#eefbf3", "#15803d", "#c3ecd3"],
};

const fmt = (n) => {
  const v = Number(n) || 0;
  return v % 1 === 0 ? v.toLocaleString("en-US")
    : v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// نسبة البطارية: خانة عشرية واحدة بلا أصفار لاحقة.
// fmt العام يفرض خانتين فيطبع 88.50% وهو ضجيج في نسبة بطارية.
const pct = (n) => {
  const v = Math.round((Number(n) || 0) * 10) / 10;
  return (v % 1 === 0 ? v : v.toFixed(1)) + "%";
};

const dt = (v) => (v ? moment(v).format("YYYY-MM-DD HH:mm") : "—");
const dOnly = (v) => (v ? moment(v).format("YYYY-MM-DD") : "—");

// key اختياري: الشارة تُستدعى منفردة أحياناً وداخل map أحياناً،
// وبلا مفتاح داخل map يحذّر React ويفقد استقرار المطابقة.
const badge = (tone, text, title, key) => (
  <span className="dr-badge" key={key === undefined ? null : key} title={title || null}
    style={{ background: tone[0], color: tone[1], borderColor: tone[2] }}>{text}</span>
);

// الاسم المركّب مكتوب بنحو المحل: name|storage|SIM|بدون بصمة|STORY|BayPass
// عرضه كسلسلة خام يجبر العين على تحليل الشرطات. نعرض الموديل بارزاً
// والبقية شارات — نفس المعلومة، بلا عمل ذهني.
const VALUE_TAGS = { "STORY": 1, "BayPass": 1, "SIM-LOCKED": 1, "بدون بصمة": 1 };
const compositeName = (raw) => {
  const s = String(raw || "").trim();
  if (!s) return <span className="dr-model">—</span>;
  const parts = s.split("|").map(x => x.trim()).filter(x => x !== "");
  if (!parts.length) return <span className="dr-model">{s}</span>;
  return (
    <span className="dr-name" title={s}>
      <span className="dr-model">{parts[0]}</span>
      {parts.slice(1).map((p, i) => (
        <span key={i} className={"dr-seg-chip" + (VALUE_TAGS[p] ? " k" : "")}>{p}</span>
      ))}
    </span>
  );
};

// الاسم الأساسي = الجزء الأول من الاسم المركّب قبل أول شرطة عمودية.
// «iPad Air 2|64GB» و «iPad Air 2|32GB» ⟵ كلاهما «iPad Air 2».
const modelOf = (raw) => {
  const s = String(raw || "").trim();
  if (!s) return "—";
  const first = s.split("|")[0].trim();
  return first || s;
};

// ما بعد الاسم الأساسي — هو ما يميّز الصنف داخل الاسم الواحد
const variantParts = (raw) => {
  const s = String(raw || "").trim();
  if (!s) return [];
  return s.split("|").slice(1).map(x => x.trim()).filter(x => x !== "");
};

// التواريخ أُزيلت من الواجهة بطلب المستخدم. الخادم ما زال يقبل
// from/to/date_field، فإعادتها لاحقاً لا تحتاج تعديل باك إند.
const EMPTY_FILTERS = {
  q: "", kind: "all", status: "all", state: "all", list_id: "",
  name: "",                       // اسم مركّب بالضبط — يُملأ بالنقر على مجموعة
  order_id: "",                   // رقم طلب — قد يحوي أكثر من جهاز
  sort: "id", dir: "DESC", limit: 50,
  include_rejected: false,
  exclude_sold: false,            // «شنو باقي عندي» — البيع لا ينقص العدّ
};

// ترتيب افتراضي مختلف لكل عرض: المجموعات بالعدد، الأجهزة بالرقم
const DEFAULT_SORT = { groups: "count", devices: "id", models: "count" };

// عرض «حسب الاسم» يجمع محلياً، فيحتاج كل الأصناف بدفعة واحدة لا صفحة.
// السبب: أصناف الاسم الواحد قد تتوزّع على صفحتين فيكذب المجموع.
const MODELS_FETCH_LIMIT = 1000;

export default class DeviceReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      f: Object.assign({}, EMPTY_FILTERS, { sort: DEFAULT_SORT.groups }),
      view: "groups",   // groups = مجمَّع حسب الجهاز (الافتراضي) | devices = مسطّح
      page: 1,
      data: null,       // عرض الأجهزة: { total, pages, summary, devices }
      groups: null,     // عرض المجموعات: { total, pages, summary, groups }
      models: null,     // عرض الأسماء: { rows, total, truncated }
      expanded: {},     // { "iPad Air 2": true } — الأسماء المفتوحة
      meta: null,       // خيارات الفلاتر
      loading: true,
      exporting: false,
      detail: null,     // { device, parts }
      detailLoading: false,
      showMoney: true,
    };
    // role يحدّد إظهار الأعمدة المالية افتراضياً — القرار مبدئي وقابل للتغيير
    const role = Number(localStorage.getItem('role'));
    this.role = role;
    this.canMoney = (role === -1 || role === 1);
    this.state.showMoney = this.canMoney;
  }

  header() { return { "Content-Type": "application/json", token: cookies.get("token") }; }

  componentDidMount() {
    this.loadMeta();
    this.load(1);
  }

  loadMeta = () => {
    axios.get(host + 'purchase/reports/filters', { headers: this.header() })
      .then(res => this.setState({ meta: (res.data && res.data.data) || null }))
      .catch(() => toast.error("تعذّر تحميل خيارات الفلاتر"));
  };

  // بناء الـ query string من الفلاتر — القيم الفارغة و "all" لا تُرسل
  qs = (over) => {
    const f = Object.assign({}, this.state.f, over || {});
    const p = [];
    const push = (k, v) => { if (v !== "" && v !== null && v !== undefined) p.push(k + "=" + encodeURIComponent(v)); };
    if (f.q) push('q', f.q.trim());
    if (f.kind && f.kind !== 'all') push('kind', f.kind);
    if (f.status && f.status !== 'all') push('status', f.status);
    if (f.state && f.state !== 'all') push('state', f.state);
    if (f.list_id) push('list_id', f.list_id);
    if (f.name) push('name', f.name);
    if (f.order_id) push('order_id', String(f.order_id).trim());
    push('sort', f.sort);
    push('dir', f.dir);
    push('page', f.page || 1);
    push('limit', f.limit);
    if (f.include_rejected) push('include_rejected', '1');
    if (f.exclude_sold) push('exclude_sold', '1');
    return '?' + p.join('&');
  };

  load = (page) => {
    const p = page || this.state.page;
    const view = this.state.view;

    // ── عرض «حسب الاسم»: دفعة واحدة كبيرة ثم تجميع محلي ──
    if (view === 'models') {
      this.setState({ loading: true });
      axios.get(host + 'purchase/reports/groups' + this.qs({ page: 1, limit: MODELS_FETCH_LIMIT }),
        { headers: this.header() })
        .then(res => {
          const d = (res.data && res.data.data) || null;
          const rows = (d && d.groups) || [];
          this.setState({
            loading: false, page: 1,
            models: {
              rows: rows,
              total: d ? d.total : rows.length,
              summary: d ? d.summary : null,
              truncated: !!(d && d.total > rows.length),
            }
          });
        })
        .catch(() => { this.setState({ loading: false }); toast.error("تعذّر تحميل التقرير"); });
      return;
    }

    const groups = view === 'groups';
    this.setState({ loading: true });
    axios.get(host + 'purchase/reports/' + (groups ? 'groups' : 'devices') + this.qs({ page: p }),
      { headers: this.header() })
      .then(res => {
        const d = (res.data && res.data.data) || null;
        this.setState(groups
          ? { loading: false, page: p, groups: d }
          : { loading: false, page: p, data: d });
      })
      .catch(() => { this.setState({ loading: false }); toast.error("تعذّر تحميل التقرير"); });
  };

  // ── تجميع الأصناف تحت اسمها الأساسي ─────────────────────
  // يُحسب في العرض لا في الحالة: الفلاتر تتغيّر فيتغيّر الناتج،
  // وتخزينه في state كان سيخلق مصدر حقيقة ثانياً يتخلّف عن الأول.
  buildModels = () => {
    const m = this.state.models;
    if (!m) return null;

    const map = {};
    const order = [];

    m.rows.forEach(g => {
      const key = modelOf(g.composite_name);
      if (!map[key]) {
        map[key] = {
          model: key, count: 0, variants: [],
          by_status: [], statusIdx: {},
          unverified: 0, unpriced: 0,
          mixed_component: false, mixed_kind: false,
          kinds: [], kindsIdx: {},
          sum_price: 0, sum_total_cost: 0,
          batt_weight: 0, batt_count: 0,
        };
        order.push(key);
      }
      const p = map[key];
      const c = Number(g.count) || 0;

      p.count += c;
      p.variants.push(g);
      p.unverified += Number(g.unverified) || 0;
      p.unpriced += Number(g.unpriced) || 0;
      if (g.mixed_component) p.mixed_component = true;
      if (g.mixed_kind) p.mixed_kind = true;
      p.sum_price += Number(g.sum_price) || 0;
      p.sum_total_cost += Number(g.sum_total_cost) || 0;

      // متوسط البطارية موزون بالعدد — المتوسط الحسابي البسيط يكذب
      // حين يكون صنف فيه ٩٠ جهازاً وآخر فيه جهاز واحد.
      const b = Number(g.avg_battery) || 0;
      if (b > 0) { p.batt_weight += b * c; p.batt_count += c; }

      if (g.kind_label && !p.kindsIdx[g.kind_label]) {
        p.kindsIdx[g.kind_label] = 1; p.kinds.push(g.kind_label);
      }

      (g.by_status || []).forEach(b2 => {
        if (p.statusIdx[b2.key] === undefined) {
          p.statusIdx[b2.key] = p.by_status.length;
          p.by_status.push({ key: b2.key, label: b2.label, count: 0 });
        }
        p.by_status[p.statusIdx[b2.key]].count += Number(b2.count) || 0;
      });
    });

    const rows = order.map(k => {
      const p = map[k];
      p.avg_cost = p.count ? p.sum_total_cost / p.count : 0;
      p.avg_battery = p.batt_count ? p.batt_weight / p.batt_count : 0;
      p.by_status.sort((a, b) => b.count - a.count);
      return p;
    });

    // الأسماء بالعدد تنازلياً — أكبر ما عندك أولاً.
    // ترتيب الأصناف داخل الاسم يتبع ترتيب الخادم كما جاء.
    rows.sort((a, b) => (b.count - a.count) || String(a.model).localeCompare(String(b.model), 'ar'));

    return {
      rows: rows,
      models_count: rows.length,
      groups_count: m.rows.length,
      devices_count: rows.reduce((n, r) => n + r.count, 0),
      sum_price: rows.reduce((n, r) => n + r.sum_price, 0),
      sum_total_cost: rows.reduce((n, r) => n + r.sum_total_cost, 0),
      truncated: m.truncated,
    };
  };

  toggleModel = (key) => {
    this.setState(s => {
      const e = Object.assign({}, s.expanded);
      if (e[key]) delete e[key]; else e[key] = true;
      return { expanded: e };
    });
  };

  expandAll = (on) => {
    const built = this.buildModels();
    if (!built) return;
    const e = {};
    if (on) built.rows.forEach(r => { e[r.model] = true; });
    this.setState({ expanded: e });
  };

  // تبديل العرض: الترتيب الافتراضي يختلف بين العرضين، فمفتاح ترتيب
  // صالح لأحدهما (id) لا معنى له في الآخر ويرجع الخادم للافتراضي.
  switchView = (view) => {
    if (view === this.state.view) return;
    const f = Object.assign({}, this.state.f, { sort: DEFAULT_SORT[view] });
    // الرجوع للتجميع يلغي حصر الاسم — وإلا بقيت مجموعة واحدة معروضة
    if (view === 'groups' || view === 'models') f.name = "";
    this.setState({ view: view, f: f, page: 1 }, () => this.load(1));
  };

  // النقر على صفّ مجموعة: ننتقل لعرض الأجهزة محصورين بهذا الاسم
  // مع الاحتفاظ ببقية الفلاتر، فالعدد المفتوح يطابق العدد المعروض.
  openGroup = (name) => {
    const f = Object.assign({}, this.state.f, { name: name, sort: DEFAULT_SORT.devices });
    this.setState({ view: 'devices', f: f, page: 1 }, () => this.load(1));
  };

  clearGroup = () => this.switchView('groups');

  // النقر على رقم طلب في أي صف: نعرض أجهزة ذلك الطلب كلها.
  // نمسح حصر الاسم المركّب لأن الطلب قد يحوي أصنافاً مختلفة —
  // إبقاؤه كان سيُخفي بقية أجهزة الطلب بلا سبب ظاهر.
  openOrder = (orderId) => {
    if (!orderId) return;
    const f = Object.assign({}, this.state.f, {
      order_id: String(orderId), name: "", sort: DEFAULT_SORT.devices,
      // الطلب كله مباع بطبيعته — إبقاء الاستبعاد يفرّغ النتيجة
      exclude_sold: false,
    });
    this.setState({ view: 'devices', f: f, page: 1 }, () => this.load(1));
  };

  clearOrder = () => {
    this.setState({ f: Object.assign({}, this.state.f, { order_id: "" }), page: 1 },
      () => this.load(1));
  };

  setF = (k, v) => {
    // أي تغيير في الفلتر يرجّع للصفحة الأولى — البقاء على صفحة ٧
    // بعد فلترة تعطي ٣ نتائج يعرض جدولاً فارغاً بلا سبب ظاهر.
    this.setState({ f: Object.assign({}, this.state.f, { [k]: v }), page: 1 });
  };

  applyAndLoad = (k, v) => {
    this.setState({ f: Object.assign({}, this.state.f, { [k]: v }), page: 1 },
      () => this.load(1));
  };

  reset = () => {
    this.setState({
      f: Object.assign({}, EMPTY_FILTERS, { sort: DEFAULT_SORT[this.state.view] }),
      page: 1,
    }, () => this.load(1));
  };

  openDetail = (id) => {
    this.setState({ detailLoading: true, detail: { device: { id: id }, parts: [] } });
    axios.get(host + 'purchase/reports/device/' + id, { headers: this.header() })
      .then(res => {
        const d = (res.data && res.data.data) || null;
        if (!d || !d.found) { this.setState({ detail: null, detailLoading: false }); toast.error("الجهاز غير موجود"); return; }
        this.setState({ detail: d, detailLoading: false });
      })
      .catch(() => { this.setState({ detail: null, detailLoading: false }); toast.error("تعذّر تحميل التفاصيل"); });
  };

  // تنزيل ملف xlsx من مصفوفة كائنات — مشترك بين التصديرين
  saveSheet = (rows, sheetName, filePrefix) => {
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/octet-stream' }),
      filePrefix + '_' + moment().format('YYYY-MM-DD_HHmm') + '.xlsx');
  };

  exportGroups = () => {
    this.setState({ exporting: true });
    axios.get(host + 'purchase/reports/groups' + this.qs({ page: 1, limit: 1000 }), { headers: this.header() })
      .then(res => {
        const d = (res.data && res.data.data) || null;
        const rows = (d && d.groups) || [];
        if (!rows.length) { this.setState({ exporting: false }); toast.info("لا توجد نتائج للتصدير"); return; }

        const byStatus = (g, key) => {
          const hit = g.by_status.filter(x => x.key === key)[0];
          return hit ? hit.count : 0;
        };

        const sheet = rows.map(g => {
          const o = {
            "الجهاز": g.composite_name,
            "النوع": g.kind_label,
            "العدد": g.count,
            "جاهز": byStatus(g, 'ready'),
            "صيانة": byStatus(g, 'sana'),
            "سوفت": byStatus(g, 'soft'),
            "بالمخزن": byStatus(g, 'stocked'),
            "مباع": byStatus(g, 'sold'),
            "بانتظار التدقيق": g.unverified,
            "بلا سعر": g.unpriced,
            "متوسط البطارية": g.avg_battery,
          };
          if (this.state.showMoney) {
            o["مجموع الشراء"] = g.sum_price;
            o["التكلفة الكلية"] = g.sum_total_cost;
            o["متوسط تكلفة الجهاز"] = g.avg_cost;
          }
          return o;
        });

        this.saveSheet(sheet, 'الأصناف', 'تقرير_الأصناف');
        this.setState({ exporting: false });
        toast.success("صُدِّر " + rows.length + " صنفاً");
        if (d.total > rows.length) toast.info("الأصناف أكثر من ١٠٠٠ — صُدِّرت الدفعة الأولى فقط");
      })
      .catch(() => { this.setState({ exporting: false }); toast.error("تعذّر التصدير"); });
  };

  // التصدير يطلب دفعة كبيرة بنفس الفلاتر — لا يصدّر الصفحة الظاهرة فقط،
  // ويتبع العرض النشط: أنت في المجموعات ⟵ يصدّر المجموعات.
  exportModels = () => {
    const built = this.buildModels();
    if (!built || !built.rows.length) { toast.info("لا توجد نتائج للتصدير"); return; }

    const byStatus = (g, key) => {
      const hit = (g.by_status || []).filter(x => x.key === key)[0];
      return hit ? hit.count : 0;
    };
    const line = (level, label, g) => {
      const o = {
        "المستوى": level,
        "الاسم": level === "اسم" ? g.model : "",
        "الصنف": level === "صنف" ? label : "",
        "النوع": level === "اسم" ? g.kinds.join(" · ") : g.kind_label,
        "العدد": g.count,
        "جاهز": byStatus(g, 'ready'),
        "صيانة": byStatus(g, 'sana'),
        "سوفت": byStatus(g, 'soft'),
        "بالمخزن": byStatus(g, 'stocked'),
        "مباع": byStatus(g, 'sold'),
        "بانتظار التدقيق": g.unverified,
        "بلا سعر": g.unpriced,
        "متوسط البطارية": g.avg_battery,
      };
      if (this.state.showMoney) {
        o["مجموع الشراء"] = g.sum_price;
        o["التكلفة الكلية"] = g.sum_total_cost;
        o["متوسط تكلفة الجهاز"] = g.avg_cost;
      }
      return o;
    };

    const sheet = [];
    built.rows.forEach(m => {
      sheet.push(line("اسم", m.model, m));
      m.variants.forEach(g => sheet.push(line("صنف", g.composite_name, g)));
    });

    this.saveSheet(sheet, 'الأسماء', 'تقرير_الأسماء');
    toast.success("صُدِّر " + built.rows.length + " اسماً و" + built.groups_count + " صنفاً");
    if (built.truncated) toast.info("الأصناف أكثر من " + MODELS_FETCH_LIMIT + " — صُدِّرت الدفعة الأولى فقط");
  };

  exportExcel = () => {
    if (this.state.view === 'models') return this.exportModels();
    if (this.state.view === 'groups') return this.exportGroups();
    this.setState({ exporting: true });
    axios.get(host + 'purchase/reports/devices' + this.qs({ page: 1, limit: 5000 }), { headers: this.header() })
      .then(res => {
        const d = (res.data && res.data.data) || null;
        const rows = (d && d.devices) || [];
        if (!rows.length) { this.setState({ exporting: false }); toast.info("لا توجد نتائج للتصدير"); return; }

        const sheet = rows.map(r => {
          const o = {
            "الرقم": r.id,
            "الاسم المركّب": r.composite_name,
            "الاسم": r.name,
            "النوع": r.kind_label,
            "الذاكرة": r.storage,
            "السيريال": r.sn,
            "IMEI": r.imei,
            "الماك": r.wifi_mac,
            "البطارية": r.battery,
            "الحالة": r.status_label,
            "الوضع": r.state_label,
            "الأعطال": r.faults_text,
            "بدون بصمة": r.no_touch_id ? "نعم" : "",
            "مقفول شبكة": r.sim_locked ? "نعم" : "",
            "شركة القفل": r.locked_carrier,
            "BayPass": r.is_bypass ? "نعم" : "",
            "طافي": r.is_floating ? "نعم" : "",
            "القائمة": r.list_id,
            "المُدخِل": r.added_by_name,
            "تاريخ الإدخال": dt(r.created_at),
            "تاريخ التدقيق": dt(r.verified_at),
            "المدقّق": r.verified_by_name,
            "تاريخ التحويل": dt(r.transferred_at),
            "تاريخ البيع": dt(r.sold_at),
            "رقم الطلب": r.order_id,
            "رقم الطلب المخزون": r.stored_order_id,
            "تعارض رقم الطلب": r.order_mismatch ? "نعم" : "",
            "ملاحظات": r.notes,
          };
          if (this.state.showMoney) {
            o["سعر الشراء"] = r.price;
            o["قطع الغيار"] = r.parts_cost;
            o["كلفة الفتح"] = r.unlock_cost;
            o["التكلفة الكلية"] = r.total_cost;
          }
          return o;
        });

        this.saveSheet(sheet, 'الأجهزة', 'تقرير_الأجهزة');
        this.setState({ exporting: false });
        toast.success("صُدِّر " + rows.length + " جهازاً");
        if (d.total > rows.length) toast.info("النتائج أكثر من ٥٠٠٠ — صُدِّرت الدفعة الأولى فقط");
      })
      .catch(() => { this.setState({ exporting: false }); toast.error("تعذّر التصدير"); });
  };

  // ===================== أجزاء العرض =====================
  renderViewSwitch() {
    const v = this.state.view;
    const tab = (key, label, hint) => (
      <button key={key} type="button" onClick={() => this.switchView(key)}
        className={"dr-seg-btn" + (v === key ? " on" : "")}>
        {label}<span className="dr-seg-hint">{hint}</span>
      </button>
    );
    return (
      <div style={{ display: "flex", gap: 13, alignItems: "center", flexWrap: "wrap", marginBottom: 18 }}>
        <div className="dr-seg">
          {tab("models", "حسب الاسم", "الأصناف تحت اسمها")}
          {tab("groups", "حسب الجهاز", "مجمَّع بالاسم المركّب")}
          {tab("devices", "كل الأجهزة", "صفّ لكل جهاز")}
        </div>
        {v === 'models' ? (
          <div style={{ display: "flex", gap: 8 }}>
            <button type="button" className="dr-btn dr-btn-ghost dr-btn-sm"
              onClick={() => this.expandAll(true)}>فتح الكل</button>
            <button type="button" className="dr-btn dr-btn-ghost dr-btn-sm"
              onClick={() => this.expandAll(false)}>طيّ الكل</button>
          </div>
        ) : null}
        {this.state.f.name ? (
          <span className="dr-crumb">
            <span>الصنف المفتوح: <b>{this.state.f.name}</b></span>
            <button type="button" className="dr-x" onClick={this.clearGroup}
              title="رجوع لكل الأصناف" aria-label="رجوع لكل الأصناف">×</button>
          </span>
        ) : null}
        {this.state.f.order_id ? (
          <span className="dr-crumb">
            <span>الطلب <b>#{this.state.f.order_id}</b></span>
            <button type="button" className="dr-x" onClick={this.clearOrder}
              title="إلغاء فلتر الطلب" aria-label="إلغاء فلتر الطلب">×</button>
          </span>
        ) : null}
      </div>
    );
  }

  renderFilters() {
    const { f, meta } = this.state;
    const lists = (meta && meta.lists) || [];
    const kinds = (meta && meta.kinds) || [];
    const statuses = (meta && meta.statuses) || [];
    const states = (meta && meta.states) || [];
    // لكل عرض قائمة ترتيب خاصة — «سعر الشراء» للجهاز الواحد لا معنى
    // له في صفّ مجموعة، و«العدد» لا معنى له في صفّ جهاز.
    const sortOptions = (this.state.view === 'groups' || this.state.view === 'models')
      ? ((meta && meta.group_sorts) || [])
      : ((meta && meta.sorts) || []);

    return (
      <div className="dr-card dr-pad">
        <div className="dr-grid">
          <div className="dr-wide">
            <label className="dr-label" htmlFor="dr-q">بحث — رقم الجهاز / سيريال / IMEI / ماك</label>
            <input id="dr-q" className="dr-input" value={f.q} placeholder="امسح الباركود أو اكتب…"
              onChange={e => this.setF('q', e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') this.load(1); }} />
          </div>

          <div>
            <label className="dr-label" htmlFor="dr-ord">رقم الطلب</label>
            <input id="dr-ord" className="dr-input" value={f.order_id} placeholder="مثلاً 1846817"
              inputMode="numeric"
              onChange={e => this.setF('order_id', e.target.value.replace(/[^\d]/g, ''))}
              onKeyDown={e => { if (e.key === 'Enter') this.load(1); }} />
          </div>

          <div>
            <label className="dr-label">نوع الجهاز</label>
            <select className="dr-select" value={f.kind} onChange={e => this.applyAndLoad('kind', e.target.value)}>
              <option value="all">كل الأنواع</option>
              {kinds.map(k => <option key={k.key} value={k.key}>{k.label} ({k.count})</option>)}
            </select>
          </div>

          <div>
            <label className="dr-label">الحالة</label>
            <select className="dr-select" value={f.status} onChange={e => this.applyAndLoad('status', e.target.value)}>
              <option value="all">كل الحالات</option>
              {statuses.map(s => <option key={s.key} value={s.key}>{s.label} ({s.count})</option>)}
            </select>
          </div>

          <div>
            <label className="dr-label">الوضع</label>
            <select className="dr-select" value={f.state} onChange={e => this.applyAndLoad('state', e.target.value)}>
              <option value="all">كل الأوضاع</option>
              {states.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
            </select>
          </div>

          <div>
            <label className="dr-label">القائمة</label>
            <select className="dr-select" value={f.list_id} onChange={e => this.applyAndLoad('list_id', e.target.value)}>
              <option value="">كل القوائم</option>
              {lists.map(l => (
                <option key={l.id} value={l.id}>
                  #{l.id} — {l.title}{l.is_closed ? "" : " (مفتوحة)"}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="dr-label">الترتيب</label>
            <select className="dr-select" value={f.sort} onChange={e => this.applyAndLoad('sort', e.target.value)}>
              {sortOptions.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
            </select>
          </div>

          <div>
            <label className="dr-label">الاتجاه</label>
            <select className="dr-select" value={f.dir} onChange={e => this.applyAndLoad('dir', e.target.value)}>
              <option value="DESC">تنازلي</option>
              <option value="ASC">تصاعدي</option>
            </select>
          </div>

          <div>
            <label className="dr-label">بالصفحة</label>
            <select className="dr-select" value={f.limit} onChange={e => this.applyAndLoad('limit', Number(e.target.value))}>
              {[25, 50, 100, 200, 500].map(n => <option key={n} value={n}>{n}</option>)}
            </select>
          </div>
        </div>

        <div className="dr-bar-actions">
          <button type="button" className="dr-btn dr-btn-primary" onClick={() => this.load(1)}>بحث</button>
          <button type="button" className="dr-btn dr-btn-ghost" onClick={this.reset}>تصفير الفلاتر</button>

          <label className="dr-toggle">
            <input type="checkbox" checked={f.exclude_sold}
              onChange={e => this.applyAndLoad('exclude_sold', e.target.checked)} />
            استبعاد المباع
          </label>
          <label className="dr-toggle">
            <input type="checkbox" checked={f.include_rejected}
              onChange={e => this.applyAndLoad('include_rejected', e.target.checked)} />
            إظهار المرفوضة
          </label>
          {this.canMoney ? (
            <label className="dr-toggle">
              <input type="checkbox" checked={this.state.showMoney}
                onChange={e => this.setState({ showMoney: e.target.checked })} />
              إظهار الأسعار والتكاليف
            </label>
          ) : null}

          <span className="dr-spacer" />
          <button type="button" className="dr-btn dr-btn-ok" disabled={this.state.exporting}
            onClick={this.exportExcel}>
            {this.state.exporting ? "جارٍ التصدير…" : "تصدير Excel"}
          </button>
        </div>
      </div>
    );
  }

  stat(label, value, sub) {
    return (
      <div className="dr-stat">
        <div className="dr-stat-l">{label}</div>
        <div className="dr-stat-v">{value}</div>
        {sub ? <div className="dr-stat-s">{sub}</div> : null}
      </div>
    );
  }

  // ===================== عرض المجموعات =====================

  renderGroupStats() {
    const g = this.state.groups;
    if (!g) return null;
    const s = g.summary;
    const money = this.state.showMoney;
    return (
      <div className="dr-stats">
        {this.stat("عدد الأصناف", fmt(s.groups_count))}
        {this.stat("مجموع الأجهزة", fmt(s.devices_count))}
        {money ? this.stat("مجموع الشراء", fmt(s.sum_price)) : null}
        {money ? this.stat("التكلفة الكلية", fmt(s.sum_total_cost),
          s.devices_count ? "متوسط الجهاز " + fmt(s.sum_total_cost / s.devices_count) : null) : null}
      </div>
    );
  }

  // شريط مجزّأ بألوان الحالات — يقرأ العدد والتركيب بنظرة واحدة
  distBar(row) {
    if (!row.count) return null;
    return (
      <div className="dr-dist" title={row.by_status.map(b => b.label + " " + b.count).join(" · ")}>
        {row.by_status.map(b => {
          const c = STATUS_STYLE[b.key] || NEUTRAL;
          return <i key={b.key} style={{ width: ((b.count / row.count) * 100) + "%", background: c[3] }} />;
        })}
      </div>
    );
  }

  renderGroups() {
    const g = this.state.groups;
    const money = this.state.showMoney;
    if (!g) return null;
    if (!g.groups.length) {
      return (
        <div className="dr-card dr-empty">
          <b>لا توجد أصناف مطابقة</b>
          وسّع الفلاتر أو اضغط «تصفير الفلاتر» للبدء من جديد.
        </div>
      );
    }

    return (
      <div className="dr-card">
        <div className="dr-scroll">
          <table className="dr-t">
            <thead>
              <tr>
                <th style={{ minWidth: 300 }}>الجهاز</th>
                <th>النوع</th>
                <th>العدد</th>
                <th style={{ minWidth: 230 }}>التوزيع</th>
                <th>تحتاج انتباه</th>
                <th>بطارية</th>
                {money ? <th className="dr-sep">مجموع الشراء</th> : null}
                {money ? <th>التكلفة</th> : null}
                {money ? <th>متوسط الجهاز</th> : null}
                <th />
              </tr>
            </thead>
            <tbody>
              {g.groups.map(row => (
                <tr key={row.composite_name} className={"dr-click" + (row.mixed_component || row.mixed_kind ? " dr-flag" : "")}
                  onClick={() => this.openGroup(row.composite_name)}>
                  <td>
                    {compositeName(row.composite_name)}
                    {this.distBar(row)}
                  </td>
                  <td>{row.kind_label}</td>
                  <td className="dr-count">{fmt(row.count)}</td>
                  <td>
                    <div className="dr-tags">
                      {row.by_status.map(b => badge(STATUS_STYLE[b.key] || NEUTRAL, b.label + " " + b.count, null, b.key))}
                    </div>
                  </td>
                  <td>
                    <div className="dr-tags">
                      {row.unverified > 0 ? badge(STATE_STYLE.unverified, "بانتظار التدقيق " + row.unverified, null, "uv") : null}
                      {row.unpriced > 0 ? badge(STATE_STYLE.needs_fix, "بلا سعر " + row.unpriced, null, "up") : null}
                      {row.mixed_component ? badge(STATE_STYLE.rejected, "أصناف متعددة", "اسم مركّب واحد موزّع على أكثر من صنف في components — سجلات متناقضة", "mc") : null}
                      {row.mixed_kind ? badge(STATE_STYLE.rejected, "أنواع متعددة", "اسم مركّب واحد بأكثر من نوع جهاز", "mk") : null}
                      {!row.unverified && !row.unpriced && !row.mixed_component && !row.mixed_kind
                        ? <span style={{ color: "#8fa0b4" }}>—</span> : null}
                    </div>
                  </td>
                  <td className="dr-num">{row.avg_battery ? pct(row.avg_battery) : "—"}</td>
                  {money ? <td className="dr-num dr-sep">{fmt(row.sum_price)}</td> : null}
                  {money ? <td className="dr-num">{fmt(row.sum_total_cost)}</td> : null}
                  {money ? <td className="dr-num" style={{ color: "#526277" }}>{fmt(row.avg_cost)}</td> : null}
                  <td>
                    <button type="button" className="dr-btn dr-btn-ghost" style={{ padding: "8px 15px", fontSize: 13.5 }}
                      onClick={e => { e.stopPropagation(); this.openGroup(row.composite_name); }}>
                      عرض الأجهزة
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // ===================== عرض الأسماء =====================

  renderModelStats(built) {
    if (!built) return null;
    const money = this.state.showMoney;
    return (
      <div className="dr-stats">
        {this.stat("عدد الأسماء", fmt(built.models_count))}
        {this.stat("عدد الأصناف", fmt(built.groups_count))}
        {this.stat("مجموع الأجهزة", fmt(built.devices_count))}
        {money ? this.stat("مجموع الشراء", fmt(built.sum_price)) : null}
        {money ? this.stat("التكلفة الكلية", fmt(built.sum_total_cost),
          built.devices_count ? "متوسط الجهاز " + fmt(built.sum_total_cost / built.devices_count) : null) : null}
      </div>
    );
  }

  // شريط التوزيع يقبل أي صف فيه count و by_status — صنفاً كان أو اسماً
  renderModels(built) {
    const money = this.state.showMoney;
    if (!built) return null;

    if (!built.rows.length) {
      return (
        <div className="dr-card dr-empty">
          <b>لا توجد أسماء مطابقة</b>
          وسّع الفلاتر أو اضغط «تصفير الفلاتر» للبدء من جديد.
        </div>
      );
    }

    return (
      <div className="dr-card">
        {built.truncated ? (
          <div className="dr-warn">
            الأصناف أكثر من {fmt(MODELS_FETCH_LIMIT)} — التجميع هنا على الدفعة الأولى فقط.
            ضيّق الفلاتر ليكون المجموع دقيقاً.
          </div>
        ) : null}

        <div className="dr-scroll">
          <table className="dr-t dr-t-models">
            <thead>
              <tr>
                <th style={{ minWidth: 320 }}>الاسم / الصنف</th>
                <th>النوع</th>
                <th>العدد</th>
                <th style={{ minWidth: 230 }}>التوزيع</th>
                <th>تحتاج انتباه</th>
                <th>بطارية</th>
                {money ? <th className="dr-sep">مجموع الشراء</th> : null}
                {money ? <th>التكلفة</th> : null}
                {money ? <th>متوسط الجهاز</th> : null}
                <th />
              </tr>
            </thead>
            <tbody>
              {built.rows.map(m => {
                const open = !!this.state.expanded[m.model];
                const single = m.variants.length === 1;
                return (
                  <React.Fragment key={m.model}>
                    <tr className="dr-mrow dr-click" onClick={() => this.toggleModel(m.model)}>
                      <td>
                        <span className="dr-name">
                          <span className={"dr-caret" + (open ? " on" : "")} aria-hidden="true">▾</span>
                          <span className="dr-model dr-mname">{m.model}</span>
                          <span className="dr-vcount">{fmt(m.variants.length)} {single ? "صنف" : "أصناف"}</span>
                        </span>
                        {this.distBar(m)}
                      </td>
                      <td>{m.kinds.length > 1 ? m.kinds.join(" · ") : (m.kinds[0] || "—")}</td>
                      <td className="dr-count dr-mcount">{fmt(m.count)}</td>
                      <td>
                        <div className="dr-tags">
                          {m.by_status.map(b => badge(STATUS_STYLE[b.key] || NEUTRAL, b.label + " " + b.count, null, b.key))}
                        </div>
                      </td>
                      <td>
                        <div className="dr-tags">
                          {m.unverified > 0 ? badge(STATE_STYLE.unverified, "بانتظار التدقيق " + m.unverified, null, "uv") : null}
                          {m.unpriced > 0 ? badge(STATE_STYLE.needs_fix, "بلا سعر " + m.unpriced, null, "up") : null}
                          {m.mixed_component ? badge(STATE_STYLE.rejected, "أصناف متعددة", "أحد أصناف هذا الاسم موزّع على أكثر من صنف في components", "mc") : null}
                          {m.mixed_kind ? badge(STATE_STYLE.rejected, "أنواع متعددة", "أحد أصناف هذا الاسم بأكثر من نوع جهاز", "mk") : null}
                          {!m.unverified && !m.unpriced && !m.mixed_component && !m.mixed_kind
                            ? <span style={{ color: "#8fa0b4" }}>—</span> : null}
                        </div>
                      </td>
                      <td className="dr-num">{m.avg_battery ? pct(m.avg_battery) : "—"}</td>
                      {money ? <td className="dr-num dr-sep">{fmt(m.sum_price)}</td> : null}
                      {money ? <td className="dr-num">{fmt(m.sum_total_cost)}</td> : null}
                      {money ? <td className="dr-num" style={{ color: "#526277" }}>{fmt(m.avg_cost)}</td> : null}
                      <td>
                        <button type="button" className="dr-btn dr-btn-ghost dr-btn-sm"
                          onClick={e => { e.stopPropagation(); this.toggleModel(m.model); }}>
                          {open ? "إخفاء الأصناف" : "عرض الأصناف"}
                        </button>
                      </td>
                    </tr>

                    {open ? m.variants.map(g => {
                      const vp = variantParts(g.composite_name);
                      return (
                        <tr key={g.composite_name} className={"dr-vrow dr-click" + (g.mixed_component || g.mixed_kind ? " dr-flag" : "")}
                          onClick={() => this.openGroup(g.composite_name)}>
                          <td>
                            <span className="dr-name dr-vname" title={g.composite_name}>
                              <span className="dr-tree" aria-hidden="true">└</span>
                              {vp.length
                                ? vp.map((p, i) => (
                                  <span key={i} className={"dr-seg-chip" + (VALUE_TAGS[p] ? " k" : "")}>{p}</span>
                                ))
                                : <span className="dr-seg-chip">بلا تفاصيل</span>}
                            </span>
                          </td>
                          <td>{g.kind_label}</td>
                          <td className="dr-count dr-vcnt">{fmt(g.count)}</td>
                          <td>
                            <div className="dr-tags">
                              {g.by_status.map(b => badge(STATUS_STYLE[b.key] || NEUTRAL, b.label + " " + b.count, null, b.key))}
                            </div>
                          </td>
                          <td>
                            <div className="dr-tags">
                              {g.unverified > 0 ? badge(STATE_STYLE.unverified, "بانتظار التدقيق " + g.unverified, null, "uv") : null}
                              {g.unpriced > 0 ? badge(STATE_STYLE.needs_fix, "بلا سعر " + g.unpriced, null, "up") : null}
                              {g.mixed_component ? badge(STATE_STYLE.rejected, "أصناف متعددة", null, "mc") : null}
                              {g.mixed_kind ? badge(STATE_STYLE.rejected, "أنواع متعددة", null, "mk") : null}
                              {!g.unverified && !g.unpriced && !g.mixed_component && !g.mixed_kind
                                ? <span style={{ color: "#8fa0b4" }}>—</span> : null}
                            </div>
                          </td>
                          <td className="dr-num">{g.avg_battery ? pct(g.avg_battery) : "—"}</td>
                          {money ? <td className="dr-num dr-sep">{fmt(g.sum_price)}</td> : null}
                          {money ? <td className="dr-num">{fmt(g.sum_total_cost)}</td> : null}
                          {money ? <td className="dr-num" style={{ color: "#526277" }}>{fmt(g.avg_cost)}</td> : null}
                          <td>
                            <button type="button" className="dr-btn dr-btn-ghost dr-btn-sm"
                              onClick={e => { e.stopPropagation(); this.openGroup(g.composite_name); }}>
                              عرض الأجهزة
                            </button>
                          </td>
                        </tr>
                      );
                    }) : null}
                  </React.Fragment>
                );
              })}

              <tr className="dr-trow">
                <td><b>المجموع الكلي</b></td>
                <td>—</td>
                <td className="dr-count dr-mcount">{fmt(built.devices_count)}</td>
                <td colSpan={3} />
                {money ? <td className="dr-num dr-sep">{fmt(built.sum_price)}</td> : null}
                {money ? <td className="dr-num">{fmt(built.sum_total_cost)}</td> : null}
                {money ? <td className="dr-num" style={{ color: "#526277" }}>
                  {fmt(built.devices_count ? built.sum_total_cost / built.devices_count : 0)}
                </td> : null}
                <td />
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // ===================== عرض الأجهزة =====================

  // ملخّص البحث برقم طلب — يميّز الحالات الثلاث التي تبدو متشابهة:
  // طلب غير موجود · طلب بلا أجهزة جديدة · فلاتر ضيّقت النتيجة.
  renderOrderBanner() {
    const d = this.state.view === 'groups' ? this.state.groups : this.state.data;
    if (!d || !d.order) return null;
    const o = d.order;

    let tone = ["#eefbf3", "#15803d", "#c3ecd3"];
    let text;
    if (o.devices_in_order === 0) {
      tone = ["#fffbeb", "#b45309", "#fde68a"];
      text = "ما في أي جهاز مربوط بهذا الطلب. إمّا الرقم غلط، أو الطلب من النظام القديم بلا أجهزة من purchase_device.";
    } else if (o.shown < o.devices_in_order) {
      tone = ["#fffbeb", "#b45309", "#fde68a"];
      text = "الطلب فيه " + fmt(o.devices_in_order) + " جهازاً، ظاهر منها "
        + fmt(o.shown) + " فقط — الفلاتر الأخرى تُخفي الباقي.";
    } else {
      text = "الطلب فيه " + fmt(o.devices_in_order) + (o.devices_in_order === 1 ? " جهاز." : " أجهزة.");
    }

    return (
      <div style={{
        background: tone[0], border: "1px solid " + tone[2], color: tone[1],
        borderRadius: 16, padding: "15px 20px", marginBottom: 16,
        fontSize: 15.5, fontWeight: 600, display: "flex", gap: 12,
        alignItems: "center", flexWrap: "wrap",
      }}>
        <b style={{ fontSize: 17, fontWeight: 800 }}>طلب #{o.id}</b>
        <span>{text}</span>
        <span className="dr-spacer" />
        <button type="button" className="dr-btn dr-btn-ghost" style={{ padding: "8px 16px", fontSize: 14 }}
          onClick={this.clearOrder}>إلغاء فلتر الطلب</button>
      </div>
    );
  }

  renderStats() {
    const d = this.state.data;
    if (!d) return null;
    const s = d.summary;
    const money = this.state.showMoney;
    return (
      <div>
        <div className="dr-stats">
          {this.stat("عدد الأجهزة", fmt(d.total))}
          {money ? this.stat("مجموع الشراء", fmt(s.sum_price)) : null}
          {money ? this.stat("التكلفة الكلية", fmt(s.sum_total_cost),
            "قطع " + fmt(s.sum_parts_cost) + " · فتح " + fmt(s.sum_unlock_cost)) : null}
          {money ? this.stat("متوسط تكلفة الجهاز", d.total ? fmt(s.sum_total_cost / d.total) : 0) : null}
          {this.stat("متوسط البطارية", pct(s.avg_battery))}
        </div>

        <div className="dr-card dr-pad">
          <div style={{ marginBottom: 13 }}>
            <div className="dr-stat-l" style={{ marginBottom: 8 }}>النوع</div>
            <div className="dr-tags">
              {s.by_kind.map(k => (
                <span key={k.key} onClick={() => this.applyAndLoad('kind', this.state.f.kind === k.key ? 'all' : k.key)}
                  className="dr-badge" style={{
                    cursor: "pointer", fontSize: 13.5, padding: "6px 14px",
                    background: this.state.f.kind === k.key ? "#1d4ed8" : "#f5f8fb",
                    color: this.state.f.kind === k.key ? "#fff" : "#334155",
                    borderColor: this.state.f.kind === k.key ? "#1d4ed8" : "#e3eaf2",
                  }}>{k.label} {fmt(k.count)}</span>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: s.flags.length ? 13 : 0 }}>
            <div className="dr-stat-l" style={{ marginBottom: 8 }}>الحالة</div>
            <div className="dr-tags">
              {s.by_status.map(k => {
                const on = this.state.f.status === k.key;
                const c = STATUS_STYLE[k.key] || NEUTRAL;
                return (
                  <span key={k.key} onClick={() => this.applyAndLoad('status', on ? 'all' : k.key)}
                    className="dr-badge" style={{
                      cursor: "pointer", fontSize: 13.5, padding: "6px 14px",
                      background: on ? c[1] : c[0], color: on ? "#fff" : c[1], borderColor: on ? c[1] : c[2],
                    }}>{k.label} {fmt(k.count)}</span>
                );
              })}
            </div>
          </div>
          {s.flags.length ? (
            <div>
              <div className="dr-stat-l" style={{ marginBottom: 8 }}>تحتاج انتباه</div>
              <div className="dr-tags">
                {s.flags.map(k => {
                  const on = this.state.f.state === k.key;
                  return (
                    <span key={k.key} onClick={() => this.applyAndLoad('state', on ? 'all' : k.key)}
                      className="dr-badge" style={{
                        cursor: "pointer", fontSize: 13.5, padding: "6px 14px",
                        background: on ? "#b45309" : "#fffbeb", color: on ? "#fff" : "#b45309",
                        borderColor: on ? "#b45309" : "#fde68a",
                      }}>{k.label} {fmt(k.count)}</span>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  renderRowTags(r) {
    const out = [];
    if (r.no_touch_id) out.push(badge(STATE_STYLE.rejected, "بدون بصمة", null, "nt"));
    if (r.sim_locked) out.push(badge(STATUS_STYLE.sana, "مقفول شبكة" + (r.locked_carrier ? " · " + r.locked_carrier : ""), null, "sl"));
    if (r.is_bypass) out.push(badge(STATUS_STYLE.soft, "BayPass", null, "bp"));
    if (r.is_floating) out.push(badge(["#f0f9ff", "#0369a1", "#bae6fd"], "طافي", null, "fl"));
    if (r.pending_mac) out.push(badge(STATE_STYLE.needs_fix, "ينتظر الماك", null, "pm"));
    if (r.was_returned) out.push(badge(STATE_STYLE.rejected, "رجع ×" + r.return_count, null, "rt"));
    if (String(r.fmi).toLowerCase() === 'locked') out.push(badge(STATE_STYLE.rejected, "آيكلاود", null, "ic"));
    if (!out.length) return null;
    return <div className="dr-tags">{out}</div>;
  }

  renderTable() {
    const d = this.state.data;
    const money = this.state.showMoney;
    if (!d) return null;
    if (!d.devices.length) {
      return (
        <div className="dr-card dr-empty">
          <b>لا توجد أجهزة مطابقة</b>
          وسّع الفلاتر، أو ارجع لعرض «حسب الجهاز» لتشوف الأصناف الموجودة.
        </div>
      );
    }

    return (
      <div className="dr-card">
        {d.order_mismatches > 0 ? (
          <div style={{
            padding: "13px 20px", background: "#fffbeb", borderBottom: "1px solid #fde68a",
            color: "#7c4a09", fontSize: 14.5, fontWeight: 600, borderRadius: "18px 18px 0 0",
          }}>
            ⚠ <b>{d.order_mismatches}</b> من صفوف هذه الصفحة رقم الطلب المخزون فيها لا يطابق الربط الفعلي.
            المعروض هو الربط الفعلي — افتح «تفاصيل» لتشوف الرقمين.
          </div>
        ) : null}
        <div className="dr-scroll">
          <table className="dr-t">
            <thead>
              <tr>
                <th>#</th>
                <th style={{ minWidth: 275 }}>الجهاز</th>
                <th>النوع</th>
                <th>السيريال / IMEI</th>
                <th>بطارية</th>
                <th>الحالة</th>
                <th>الوضع</th>
                <th>الأعطال</th>
                {money ? <th className="dr-sep">شراء</th> : null}
                {money ? <th>التكلفة</th> : null}
                <th className="dr-sep">القائمة</th>
                <th>المُدخِل</th>
                <th>الإدخال</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {d.devices.map(r => {
                const ss = STATUS_STYLE[r.status] || NEUTRAL;
                const st = STATE_STYLE[r.state] || STATE_STYLE.unverified;
                return (
                  <tr key={r.id} className={r.is_rejected ? "dr-flag" : ""}>
                    <td className="dr-num" style={{ color: "#1d4ed8", fontWeight: 800 }}>{r.id}</td>
                    <td>
                      {compositeName(r.composite_name)}
                      {this.renderRowTags(r)}
                    </td>
                    <td>{r.kind_label}</td>
                    <td>
                      <div className="dr-mono">{r.sn || "—"}</div>
                      {r.imei ? <div className="dr-mono" style={{ color: "#526277" }}>{r.imei}</div> : null}
                      {r.wifi_mac ? <div className="dr-mono" style={{ color: "#a9b7c8", fontSize: 12.5 }}>{r.wifi_mac}</div> : null}
                    </td>
                    <td className="dr-num">{r.battery ? pct(r.battery) : "—"}</td>
                    <td>
                      {badge(ss, r.status_label)}
                      {r.order_id ? (
                        <div style={{ marginTop: 3 }}>
                          <button type="button" onClick={() => this.openOrder(r.order_id)}
                            title="عرض كل أجهزة هذا الطلب"
                            style={{
                              font: "inherit", fontSize: 12.5, fontWeight: 700, color: "#1d4ed8",
                              background: "none", border: 0, padding: 0, cursor: "pointer",
                              textDecoration: "underline", textUnderlineOffset: 3,
                            }}>طلب #{r.order_id}</button>
                        </div>
                      ) : null}
                      {r.order_mismatch
                        ? <div style={{ fontSize: 12, color: "#b45309", marginTop: 3, fontWeight: 700 }}
                          title={"العمود المخزون يقول #" + r.stored_order_id + " لكن الربط الفعلي عبر iphone_packaging_orders "
                            + (r.order_id ? "يقول #" + r.order_id : "غير موجود")}>
                          ⚠ رقم طلب عالق
                        </div>
                        : null}
                    </td>
                    <td>
                      {badge(st, r.state_label)}
                      {r.is_rejected && r.reject_reason
                        ? <div style={{ fontSize: 12.5, color: "#b91c1c", marginTop: 3 }}>{r.reject_reason}</div> : null}
                      {r.needs_fix && r.fix_note
                        ? <div style={{ fontSize: 12.5, color: "#b45309", marginTop: 3 }}>{r.fix_note}</div> : null}
                    </td>
                    <td style={{ maxWidth: 175, fontSize: 14 }}>{r.faults_text || "—"}</td>
                    {money ? <td className="dr-num dr-sep" style={r.price ? null : { color: "#dc2626" }}>{fmt(r.price)}</td> : null}
                    {money ? <td className="dr-num">{fmt(r.total_cost)}</td> : null}
                    <td className="dr-num dr-sep" style={{ color: "#526277" }}>{r.list_id ? "#" + r.list_id : "—"}</td>
                    <td style={{ fontSize: 14 }}>{r.added_by_name || "—"}</td>
                    <td className="dr-num" style={{ color: "#526277", fontWeight: 600, fontSize: 14 }}>{dOnly(r.created_at)}</td>
                    <td>
                      <button type="button" className="dr-btn dr-btn-ghost" style={{ padding: "8px 15px", fontSize: 13.5 }}
                        onClick={() => this.openDetail(r.id)}>تفاصيل</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderPager() {
    // عرض «حسب الاسم» يجلب كل الأصناف بدفعة واحدة — لا صفحات
    if (this.state.view === 'models') return null;
    const d = this.state.view === 'groups' ? this.state.groups : this.state.data;
    if (!d || d.pages <= 1) return null;
    const unit = this.state.view === 'groups' ? 'صنفاً' : 'جهازاً';
    const p = d.page, last = d.pages;
    const btn = (label, to, disabled, on) => (
      <button key={label + "-" + to} type="button" disabled={disabled}
        className={"dr-pg" + (on ? " on" : "")}
        onClick={() => { if (!disabled) this.load(to); }}>{label}</button>
    );
    const nums = [];
    const from = Math.max(1, p - 2), to = Math.min(last, p + 2);
    for (let i = from; i <= to; i++) nums.push(btn(String(i), i, false, i === p));

    return (
      <div className="dr-pager">
        {btn("الأولى", 1, p === 1)}
        {btn("السابق", p - 1, p === 1)}
        {nums}
        {btn("التالي", p + 1, p === last)}
        {btn("الأخيرة", last, p === last)}
        <span className="dr-pgtxt">صفحة {p} من {last} — {fmt(d.total)} {unit}</span>
      </div>
    );
  }

  // ===================== نافذة التفاصيل =====================

  renderDetail() {
    const d = this.state.detail;
    if (!d) return null;
    const v = d.device || {};
    const money = this.state.showMoney;
    const kv = (k, val) => (
      <div className="dr-kv" key={k}>
        <div className="dr-k">{k}</div>
        <div className="dr-v">{(val === "" || val === null || val === undefined) ? "—" : val}</div>
      </div>
    );
    const sect = (t) => <div className="dr-sect">{t}</div>;

    return (
      <div className="dr-ov" onClick={() => this.setState({ detail: null })}>
        <div className="dr-modal" onClick={e => e.stopPropagation()}>
          <div className="dr-mhead">
            <div>
              <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 5 }}>
                {compositeName(v.composite_name || v.name)}
              </div>
              <div style={{ fontSize: 13.5, color: "#526277" }}>رقم الجهاز (الباركود): {v.id}</div>
            </div>
            <button type="button" className="dr-btn dr-btn-ghost" onClick={() => this.setState({ detail: null })}>إغلاق</button>
          </div>

          {this.state.detailLoading ? <div className="dr-empty">جارٍ التحميل…</div> : (
            <div className="dr-mbody">
              {sect("الهوية")}
              {kv("الماك (الهوية)", v.wifi_mac || "— طافي بلا ماك")}
              {kv("السيريال", v.sn)}
              {v.previous_sn ? kv("السيريال السابق", v.previous_sn) : null}
              {kv("IMEI", v.imei)}
              {kv("طريقة الإدخال", v.entry_mode === 'manual' ? "يدوي (طافي)" : "بالكيبل")}

              {sect("المواصفات")}
              {kv("النوع", v.kind_label)}
              {kv("الذاكرة", v.storage)}
              {kv("البطارية", v.battery ? pct(v.battery) : "—")}
              {kv("التفعيل", v.activation)}
              {kv("iCloud / FMI", v.fmi)}
              {kv("دعم الشريحة", v.sim_support ? "نعم" : "لا")}
              {kv("قفل الشبكة", v.sim_locked ? ("مقفول" + (v.locked_carrier ? " — " + v.locked_carrier : "")) : "مفتوح")}
              {kv("بدون بصمة", v.no_touch_id ? "نعم" : "لا")}
              {kv("الستوري", v.story)}
              {kv("الأعطال", v.faults_text)}

              {sect("المسار")}
              {kv("الحالة", v.status_label)}
              {kv("الوضع", v.state_label)}
              {kv("القائمة", v.list_id ? "#" + v.list_id : "—")}
              {kv("المُدخِل", (v.added_by_name || "—") + " — " + dt(v.created_at))}
              {kv("التدقيق", v.verified_at ? dt(v.verified_at) + " — " + (v.verified_by_name || "") : "لم يُدقَّق بعد")}
              {v.verify_note ? kv("ملاحظة التدقيق", v.verify_note) : null}
              {v.needs_fix ? kv("سبب الإعادة للتصحيح", v.fix_note) : null}
              {v.is_rejected ? kv("سبب الرفض", v.reject_reason + " — " + (v.rejected_by_name || "") + " — " + dt(v.rejected_at)) : null}
              {v.was_returned ? kv("الرجوع", "×" + v.return_count + " — " + v.return_reason) : null}
              {kv("إنهاء الصيانة/السوفت", v.finished_at ? dt(v.finished_at) + " — " + (v.finished_by_name || "") : "—")}
              {kv("التحويل للمخزن", v.transferred_at ? dt(v.transferred_at) + " — " + (v.transferred_by_name || "") : "—")}

              {v.sold_at || v.order_id || v.stored_order_id ? (
                <div>
                  {sect("البيع")}
                  {kv("تاريخ البيع", dt(v.sold_at))}
                  {kv("رقم الطلب", v.order_id
                    ? <span><b style={{ fontSize: 17 }}>#{v.order_id}</b>
                      <span style={{ color: "#8fa0b4", fontSize: 13, marginInlineStart: 8 }}>order_from.id</span></span>
                    : <span style={{ color: "#b45309", fontWeight: 700 }}>لا يوجد ربط فعلي بطلب</span>)}
                  {v.packaging_line_id ? kv("سطر التغليف", "#" + v.packaging_line_id) : null}
                  {v.order_id ? (
                    <button type="button" className="dr-btn dr-btn-ghost" style={{ marginTop: 10 }}
                      onClick={() => { this.setState({ detail: null }); this.openOrder(v.order_id); }}>
                      عرض كل أجهزة الطلب #{v.order_id}
                    </button>
                  ) : null}
                  {v.order_mismatch ? (
                    <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 12, padding: "13px 16px", marginTop: 12 }}>
                      <div style={{ fontWeight: 800, color: "#b45309", marginBottom: 5 }}>⚠ العمود المخزون لا يطابق الربط الفعلي</div>
                      <div style={{ fontSize: 14, color: "#7c4a09", lineHeight: 1.7 }}>
                        <div>purchase_device.sold_order_id = <b>{v.stored_order_id === null ? "فارغ" : "#" + v.stored_order_id}</b></div>
                        <div>الربط عبر iphone_packaging_orders = <b>{v.order_id ? "#" + v.order_id : "لا يوجد"}</b></div>
                        <div style={{ marginTop: 6 }}>المعروض أعلاه هو <b>الربط الفعلي</b>. العمود عالق من فكّ ربط سابق لم يُصفَّر.</div>
                      </div>
                    </div>
                  ) : (
                    <div style={{ fontSize: 12.5, color: "#8fa0b4", marginTop: 7 }}>
                      الرقم مقروء من الربط الفعلي (iphone_packaging_orders ← packaging ← order_from)،
                      لا من العمود المخزون.
                    </div>
                  )}
                </div>
              ) : null}

              {v.notes ? <div>{sect("ملاحظات")}{kv("النص", v.notes)}</div> : null}

              {money ? (
                <div className="dr-box">
                  {sect("التكلفة")}
                  {kv("سعر الشراء", fmt(v.price))}
                  {kv("قطع الغيار", fmt(v.parts_cost))}
                  {kv("كلفة الفتح", fmt(v.unlock_cost))}
                  {kv("التكلفة الكلية", <b style={{ fontSize: 17 }}>{fmt(v.total_cost)}</b>)}
                  <div style={{ fontSize: 12.5, color: "#8fa0b4", marginTop: 7 }}>
                    التكلفة الكلية عمود محسوب في القاعدة — لا يُكتب يدوياً.
                  </div>
                </div>
              ) : null}

              {d.parts && d.parts.length > 0 ? (
                <div>
                  {sect("القطع المركّبة (" + d.parts.length + ")")}
                  <table className="dr-t" style={{ marginTop: 6 }}>
                    <thead><tr>
                      <th style={{ position: "static" }}>القطعة</th>
                      <th style={{ position: "static" }}>العدد</th>
                      {money ? <th style={{ position: "static" }}>الكلفة</th> : null}
                      <th style={{ position: "static" }}>التاريخ</th>
                    </tr></thead>
                    <tbody>
                      {d.parts.map(p => (
                        <tr key={p.id}>
                          <td>{p.name}</td>
                          <td className="dr-num">{p.qty}</td>
                          {money ? <td className="dr-num">{fmt(p.total_cost)}</td> : null}
                          <td className="dr-num" style={{ color: "#526277" }}>{dOnly(p.created_at)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const view = this.state.view;
    const groups = view === 'groups';
    const models = view === 'models';
    const built = models ? this.buildModels() : null;
    return (
      <div className="dr-root">
        <style dangerouslySetInnerHTML={{ __html: CSS }} />
        <ToastContainer position="top-center" autoClose={2500} rtl />
        <div className="dr-shell">
          <div className="dr-head">
            <div>
              <h1 className="dr-h1">تقارير الأجهزة</h1>
              <p className="dr-sub">
                {models
                  ? "كل اسم بمجموعه، وتحته أصنافه — اضغط على الاسم ليفتح."
                  : groups
                    ? "كم جهازاً من كل صنف — اضغط على أي صف لتشوف أجهزته."
                    : "صفّ لكل جهاز. عرض فقط، لا يعدّل العدد ولا التكلفة."}
              </p>
            </div>
          </div>

          {this.renderViewSwitch()}
          {this.renderFilters()}

          {this.state.loading && !this.state.data && !this.state.groups && !this.state.models
            ? <div className="dr-card dr-empty">جارٍ التحميل…</div>
            : (
              <div style={this.state.loading ? { opacity: .5 } : null}>
                {this.renderOrderBanner()}
                {models
                  ? <React.Fragment>{this.renderModelStats(built)}{this.renderModels(built)}</React.Fragment>
                  : groups
                    ? <React.Fragment>{this.renderGroupStats()}{this.renderGroups()}</React.Fragment>
                    : <React.Fragment>{this.renderStats()}{this.renderTable()}</React.Fragment>}
                {this.renderPager()}
              </div>
            )}
        </div>
        {this.renderDetail()}
      </div>
    );
  }
}
